import './purpleairWebpage.css';
import * as React from 'react';
import PurpleairWebpageAll from './purpleairWebpageAll';
import PurpleairWebpageRecent from './purpleairWebpageRecent';

import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import PurpleairWebpageSensor from './purpleairWebpageStatus';
import PurpleairWebpageIncidentSiteSpecific from './purpleairWebpageIncidentSiteSpecific';
import PageAfterHours from './pageAfterHours';


const PurpleairSensor = () => {
  const [tabvalue, setTabValue] = React.useState('1');

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };


  return (
    <>
      <div >
        <div>
          <TabContext value={tabvalue}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleChange}  >
                <Tab label="Recent Readings" value="1"
                  sx={{
                    mr: 1,
                    borderRadius: 1,
                    px: 3,
                    py: 1,
                    textTransform: 'none',
                    bgcolor: '#cae6fd',
                    color: '#7C7C7C',
                    '&.Mui-selected': {
                      color: 'black',
                      bgcolor: '#c0e1fd'
                    },
                    '&:hover': {
                      bgcolor: tabvalue === '1' ? '#c0e1fd' : '#dbeefe',
                    },
                  }} />
                <Tab label="All Readings" value="2"
                  sx={{
                    mr: 1,
                    borderRadius: 1,
                    px: 3,
                    py: 1,
                    textTransform: 'none',
                    bgcolor: '#cae6fd',
                    color: '#7C7C7C',
                    '&.Mui-selected': {
                      color: 'black',
                      bgcolor: '#c0e1fd'
                    },
                    '&:hover': {
                      bgcolor: tabvalue === '2' ? '#c0e1fd' : '#dbeefe',
                    },
                  }} />
                <Tab label="Sensor Status" value="3"
                  sx={{
                    mr: 1,
                    borderRadius: 1,
                    px: 3,
                    py: 1,
                    textTransform: 'none',
                    bgcolor: '#cae6fd',
                    color: '#7C7C7C',
                    '&.Mui-selected': {
                      color: 'black',
                      bgcolor: '#c0e1fd'
                    },
                    '&:hover': {
                      bgcolor: tabvalue === '3' ? '#c0e1fd' : '#dbeefe',
                    },
                  }} />
                <Tab label="Hazard Graph" value="4"
                  sx={{
                    mr: 1,
                    borderRadius: 1,
                    px: 3,
                    py: 1,
                    textTransform: 'none',
                    bgcolor: '#cae6fd',
                    color: '#7C7C7C',
                    '&.Mui-selected': {
                      color: 'black',
                      bgcolor: '#c0e1fd'
                    },
                    '&:hover': {
                      bgcolor: tabvalue === '4' ? '#c0e1fd' : '#dbeefe',
                    },
                  }} />
                <Tab label="After hour Operations" value="5"
                  sx={{
                    mr: 1,
                    borderRadius: 1,
                    px: 3,
                    py: 1,
                    textTransform: 'none',
                    bgcolor: '#cae6fd',
                    color: '#7C7C7C',
                    '&.Mui-selected': {
                      color: 'black',
                      bgcolor: '#c0e1fd'
                    },
                    '&:hover': {
                      bgcolor: tabvalue === '5' ? '#c0e1fd' : '#dbeefe',
                    },
                  }} />
              </TabList>
            </Box>
            <TabPanel value="1"><PurpleairWebpageRecent /></TabPanel>
            <TabPanel value="2"><PurpleairWebpageAll /></TabPanel>
            <TabPanel value="3"><PurpleairWebpageSensor /></TabPanel>
            <TabPanel value="4"><PurpleairWebpageIncidentSiteSpecific /></TabPanel>
            <TabPanel value="5"><PageAfterHours /></TabPanel>
          </TabContext>
        </div>
      </div>
    </>
  );
}

export default PurpleairSensor;